import "./about.css";
import AboutImage from "../../assets/Avanish3.jpg";
// import CV from "../../assets/Avnish_kumar_Bind_Resume.pdf";
import Resume from "../../assets/Avanish_Bind_Resume.pdf";
// import { BiDownload } from "react-icons/bi";
import { BiShow } from 'react-icons/bi';
import Card from "../../components/Card";
import data from "./data.js"



function About() {

    return (
        <section id="about">
            <div className="container about__container">
                <div className="about__left">
                    <div className="about__portrait">
                        <img src={AboutImage} alt="about image" />
                    </div>

                </div>
                <div className="about__right">
                    <h2>About Me</h2>
                    <div className="about__cards">
                        {
                            data.map(item => (
                                <Card key={item.id} className="about__card">
                                    <span className="about__card-icon">{item.icon}</span>
                                    <h5>{item.title}</h5>
                                    <small>{item.desc}</small>
                                </Card>

                            ))
                        }
                    </div>
                    <p>
                        I'm Avanish Kumar, a Software Engineer and Computer Science graduate from Lovely Professional University. With over a year of experience, I've worked on real-world projects using C++, JavaScript, and modern web technologies.
                    </p>

                    <p>
                        I enjoy solving problems, building clean and scalable solutions, and constantly learning new tools and techniques. Check out my portfolio to see what I've been working on!
                    </p>


                    {/* <a href={CV} download className="btn primary"> Download CV <BiDownload /></a> */}
                    <a href={Resume} target="_blank" rel="noopener noreferrer" className="btn primary">
  See Resume <BiShow />
</a>

                </div>
            </div>
        </section>
    )

}
export default About;